import { createSelector } from 'reselect'

const getStudentViewData = state => state.student
const getSlideId = (state, slide_uid) => slide_uid

const oeqSubmissionReadySelector = createSelector(
	[ getStudentViewData, getSlideId ],
	(student, slideId) => {
		const slide_data = student.slides[slideId]
		return slide_data.audioClientUid === ''
		|| (slide_data.audioClientUid !== '' && slide_data.audioServerUid !== '')
	}
)

export default oeqSubmissionReadySelector
